"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameVPNRecommendations = void 0;
var react_1 = require("react");
var next_intl_1 = require("next-intl");
var useGameVPNRecommendations = function (gameData) {
    var t = (0, next_intl_1.useTranslations)('translation');
    var tCountry = (0, next_intl_1.useTranslations)('country');
    var iframeRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(false), isIframeLoaded = _a[0], setIframeLoaded = _a[1];
    var preparedCountries = (0, react_1.useMemo)(function () {
        var _a, _b;
        var countries = (_b = (_a = gameData === null || gameData === void 0 ? void 0 : gameData.settings) === null || _a === void 0 ? void 0 : _a.supportCountries) !== null && _b !== void 0 ? _b : [];
        return countries.map(tCountry).join(', ');
    }, [gameData, tCountry]);
    var preparedText = (0, react_1.useMemo)(function () {
        if (!preparedCountries)
            return null;
        var countriesHTML = "<strong style=\"color: #f4ae59\">".concat(preparedCountries, "</strong>");
        return {
            title: t('openGameErrorTitle'),
            description: t('openGameErrorText', { countries: countriesHTML }),
            countries: preparedCountries,
        };
    }, [preparedCountries, t]);
    (0, react_1.useEffect)(function () {
        var iframe = iframeRef.current;
        if (!iframe)
            return;
        var handleLoad = function () { return setIframeLoaded(true); };
        iframe.addEventListener('load', handleLoad);
        return function () { return iframe.removeEventListener('load', handleLoad); };
    }, []);
    (0, react_1.useEffect)(function () {
        var iframe = iframeRef.current;
        if (isIframeLoaded && preparedText && (iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow)) {
            try {
                iframe.contentWindow.postMessage(preparedText, '*');
            }
            catch (err) { }
        }
    }, [isIframeLoaded, preparedText]);
    return (0, react_1.useCallback)(function (node) {
        iframeRef.current = node;
    }, []);
};
exports.useGameVPNRecommendations = useGameVPNRecommendations;
